<template>
  <div class="home-page-hero-container">
    <section class="section hero is-primary home-page-hero">
      <img
        src="https://images.squarespace-cdn.com/content/v1/6156ae0e51accc195cc3b7f9/1633102571720-WCQG0CMYKGDT25B8OSM3/hidden-profile-with-resume-27.png?format=1500w"
        style="width: 50%; top: 30%; position: absolute; right: 2rem;"
        class="hero-image"
      />
      <slot></slot>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomePageHero'
};
</script>

<style scoped lang="scss">
.home-page-hero {
  position: absolute;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-image: url('https://images.squarespace-cdn.com/content/v1/6156ae0e51accc195cc3b7f9/1633072991626-WFUUVS768ATWFBSNP6IV/backgrounds-18.png?format=2500w');
  background-size: cover;
  background-repeat: no-repeat;
}

.home-page-hero-container {
  background-color: rgba($white-ter, 0.5);
  width: 100vw;
  height: 100vh;
}

.button.is-large {
  height: 3.25em;
  padding-left: 2rem;
  padding-right: 2rem;
  font-weight: bold;
}

.hero.is-primary {
  background-color: rgba($white-ter, 0.5);
  height: 100vh;
}

.hero-body {
  flex-grow: 0;
  margin: auto !important;

  @media screen and (max-width: 767px) {
    margin: 0 !important;
  }
}

.columns {
  margin: auto;
}

.subtitle.tagline {
  padding-bottom: 2rem;
}

@media screen and (min-width: 1088px) {
  .section.is-large {
    padding: 1rem 1.5rem;
  }
}

@media screen and (max-width: 1088px) {
  .container {
    margin: 0;
  }
}

.line-space-tall {
  line-height: 2.25rem;
}

.title sup,
.subtitle sup {
  font-size: 0.75em;
}

.subtitle:not(:last-child) {
  margin-bottom: 0.5rem;
}

.is-invisible {
  opacity: 0 !important;
}

// vertically center demo
html {
  display: table;
  height: 100%;
  width: 100%;
}

body {
  display: table-cell;
  vertical-align: middle;
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-enter/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.tagline {
  font-family: "Montserrat Alternates";
}

.hero-image {
  @media screen and (max-width: 767px) {
    display: none;
  }
}
</style>
